import Swal from 'sweetalert2';

/**
 * Catálogo de códigos de error para el flujo de autenticación.
 * Úsalos para identificar dónde buscar el problema:
 *
 *   AUTH-xxx     → flujo OIDC (OidcCallback, renovación de sesión)
 *   DB-1xx       → lectura de usuario en Firebase via API
 *   DB-2xx       → escritura/registro de usuario en Firebase via API
 *   API-4xx/5xx  → respuesta HTTP del VPS
 *   API-NET-7xx  → problemas de red/conectividad antes de recibir respuesta
 */
export const ERROR_CODES = {
  // OIDC
  AUTH_OIDC_CALLBACK: 'AUTH-001',  // signinRedirectCallback falló
  AUTH_SILENT_RENEW:  'AUTH-002',  // renovación silenciosa falló
  AUTH_SESSION_CHECK: 'AUTH-003',  // getUser() lanzó error
  // Base de datos — lectura
  DB_READ_FETCH:      'DB-101',    // fallo de red/HTTP al consultar /api/read
  DB_READ_EMPTY:      'DB-102',    // respuesta vacía o formato inesperado de Firebase
  // Base de datos — escritura
  DB_WRITE_REGISTER:  'DB-201',    // fallo al auto-registrar usuario nuevo
  DB_WRITE_UPDATE:    'DB-202',    // fallo al actualizar ultimaConexion u otro campo
  // API HTTP
  API_UNAUTHORIZED:   'API-401',
  API_FORBIDDEN:      'API-403',
  API_SERVER:         'API-500',
  // Red / conectividad
  API_NET_DNS:        'API-NET-701',  // dominio no resuelve
  API_NET_DOWN:       'API-NET-702',  // servicio Node/PM2 caído
  API_NET_CORS:       'API-NET-703',  // CORS bloqueado por el navegador
  API_NET_TLS:        'API-NET-704',  // certificado TLS inválido o expirado
  API_NET_TIMEOUT:    'API-NET-705',  // timeout sin respuesta
};

/**
 * Muestra una alerta SweetAlert2 amigable con el código de error.
 * @param {string} code      - Código del catálogo ERROR_CODES
 * @param {string} [detail]  - Detalle técnico (solo se imprime en consola)
 * @param {object} [jwtInfo] - { aud, iss, exp } del access_token decodificado
 */
export function showAuthError(code, detail = '', jwtInfo = null) {
  if (detail) console.error(`[${code}]`, detail);

  const clientId = process.env.REACT_APP_OIDC_CLIENT_ID || '—';
  const audId = process.env.OIDC_AUDIENCE || '—';
  const expectedAud = `${clientId}`;

  const jwtHtml = jwtInfo
    ? `<hr style="margin:10px 0;border-color:#eee">
       <div style="text-align:left;font-size:0.72rem;color:#555;font-family:monospace;word-break:break-all;line-height:1.6">
         <b>aud:</b> ${Array.isArray(jwtInfo.aud) ? jwtInfo.aud.join(', ') : jwtInfo.aud}<br>
         <b>iss:</b> ${jwtInfo.iss}<br>
         <b>exp:</b> ${jwtInfo.exp}<br>
         <span style="color:#888"><b>cliente esperado:</b> ${expectedAud} y aud: ${audId}</span>
       </div>`
    : '';

  Swal.fire({
    icon: 'warning',
    title: '¡Ups! Algo no anda bien',
    html: `
      Ocurrió un problema al iniciar tu sesión.<br>
      Por favor intenta de nuevo o contacta a soporte.<br><br>
      <span style="font-size:0.78rem;color:#9e9e9e">
        Código de error: <b>${code}</b>
      </span>
      ${jwtHtml}
    `,
    confirmButtonText: 'Entendido',
    confirmButtonColor: '#1976d2',
    background: '#fff',
    customClass: { popup: 'swal-auth-error' },
  });
}
